export default "__VITE_ASSET__f7152de2__"